/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type TranscodingJobStatus = typeof TranscodingJobStatus[keyof typeof TranscodingJobStatus];


export const TranscodingJobStatus = {
  pending: 'pending',
  requested: 'requested',
  succeeded: 'succeeded',
  failed: 'failed',
  superseded: 'superseded',
} as const;
